export default __webpack_public_path__ + "static/media/CurriculumImage.be165884.svg";